import { useMemo } from 'react';

import { useDerivedServiceModeContext } from 'state/service-mode/derived';

export function useMenuQueryOptions() {
  const { posServiceMode } = useDerivedServiceModeContext();

  const value = useMemo(() => ({ posServiceMode }), [posServiceMode]);
  return value;
}
